// Sroll to Top Button
var scrollTop = $("#scrollTop");
$(scrollTop).click(function() {
    $('html, body').animate({
        scrollTop: 0
    }, 800);
    return false;
});
// END Sroll to Top Button

//Nav Desktop Alert Msg Sweetalear2 
let pageAlert = 0;
let errorShow = [];

$('.nav-login .invalid-feedback').each(function() {
    if($('.nav-login .invalid-feedback').css('display') == 'block'){
        let getAlertMsg = $(this).find('.alert-msg').text();
        let errorMsg = '<i><sup>*</sup>' + getAlertMsg + '</i><br>';
        
        errorShow.push(errorMsg);
        pageAlert = 1;    
    }  
});
let errorHtml = errorShow.join(' ');

// var urlPathName = location.pathname;
var urlPathName = window.location.pathname.split("/").pop();

if (urlPathName == "register") {
    pageAlert = 2;
}else if (urlPathName == "login") {
    pageAlert = 2;
}else if (urlPathName == "reset") {
    pageAlert = 2;
}else if (pageAlert == 1){
    Swal.fire({
        icon: 'error',
        title: 'Oops...',
        html: errorHtml
    })
}
//END Nav Desktop Alert Msg Sweetalear2 

//Main Wallet Auto Transfer Hover
$( "#desktopNav .auto-transfer" ).mouseenter(function() {
    $( "#desktopNav .auto-transfer p.title" ).addClass('hidden');
    $( "#desktopNav .auto-transfer label" ).removeClass('hidden')
}).mouseleave(function() {
    $( "#desktopNav .auto-transfer p.title" ).removeClass('hidden');
    $( "#desktopNav .auto-transfer label" ).addClass('hidden')
});
